import { EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Col, Form, Input, Row, Steps, Table } from "antd";
import { _adr } from "../../../address";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { NotFound } from "../../../sources/svg/svg";
import { useDealer } from "../../../tools/api";
import { useState } from "react";

import style from "./list.module.scss";
import { convertToJalaliWithTime, validateInput } from "../../../tools/tools";
import Iinput from "../../auxiliary/inputs/Input";
import { Link } from "react-router-dom";

const CDList = () => {
	const { queryBankCardProfileByCertNo } = useDealer();
	const [t] = useTranslation("global");

	const [frmService] = Form.useForm();

	const [list, setList] = useState({
		isProgress: false,
		isActive: false,
		result: [],
	});

	const handleSearch = async ({ certno }) => {
		try {
			setList((l) => ({ ...l, isProgress: true }));
			if (certno) {
				const payload = {
					certno,
				};
				const response = await queryBankCardProfileByCertNo(payload);
				if (response) {
					setList((list) => ({ ...list, result: response?.Result, isActive: true }));
				}
			}
			setList((l) => ({ ...l, isProgress: false }));
		} catch (error) {
			console.error(error);
			setList((l) => ({ ...l, isProgress: false }));
		}
	};
	return (
		<>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={0}
										responsive
										items={[
											{
												title: "ورود کدملی",
											},
											{
												title: "اطلاعات هویتی",
											},
											{
												title: "آپلود مدارک",
											},
											{
												title: "کارت بانکی",
											},
											{
												title: "بررسی نهایی",
											},
										]}
									/>
								</div>
							</div>
							<div className="holder-form-filter">
								<br />
								<Form id="frmService" name="frmService" layout="vertical" form={frmService} onFinish={handleSearch}>
									<Row justify={"start"}>
										<Col xxl={6}>
											<Form.Item
												className="input-normal"
												name="certno"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "number",
														length: 10,
													}),
												]}>
												<Iinput placeholder="جستجو کدملی" dir="ltr" />
											</Form.Item>
										</Col>
										<Col xxl={6} style={{ margin: "0", flex: "0 0 15%" }}>
											<Button htmlType="submit" key={frmService} className={`btn-normal btn-green ${style.button}`}>
												جستجو
											</Button>
										</Col>
									</Row>
								</Form>
							</div>
							{list.isActive && (
								<div className="holder-table">
									<Table
										className="tbl-normal"
										columns={[
											{
												title: "نام و نام خانوادگی",
												dataIndex: "fullname",
												key: "fullname",
												width: 150,
											},
											{
												title: "تاریخ تولد",
												dataIndex: "birthday",
												key: "birthday",
												width: 150,
											},
											{
												title: "کدملی",
												dataIndex: "certno",
												key: "certno",
												width: 150,
											},
											{
												title: "شماره پاسپورت",
												dataIndex: "pasport",
												key: "pasport",
												width: 150,
											},
											{
												title: "وضعیت پروفایل",
												dataIndex: "profilestatus",
												key: "profilestatus",
												width: 150,
											},
											{
												title: "وضعیت پرداخت",
												dataIndex: "paymentstatus",
												key: "paymentstatus",
												width: 150,
											},
											{
												title: "اطلاعات طرح",
												dataIndex: "plan",
												key: "plan",
												width: 150,
											},
											{
												title: "عملیات",
												dataIndex: "action",
												key: "action",
												width: 150,
											},
										]}
										scroll={{ y: "100%" }}
										locale={{
											emptyText: (
												<>
													<NotFound text={"رکوردی یافت نشد."} />
												</>
											),
										}}
										pagination={{
											className: "page-pagination",
											// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
											onChange: (page) => {
												// setCurrentPage(page);
											},
											pageSize: 10,
											align: "start",
											// current: currentPage === 0 ? 1 : currentPage,
											// total: totalRecord,
											showSizeChanger: false,
										}}
										dataSource={list?.result.map((item, key) => ({
											key: key,
											fullname: (
												<>
													{item?.firstName + " " + item.lastName} <br />
													{item.firstNameEn + " " + item.lastNameEn}
												</>
											),
											birthday: (
												<>
													<span dir="ltr">{item?.birthdate?.toString()?.split("T")[0]}</span>
													<br />
													{convertToJalaliWithTime(item.birthdate)}
												</>
											),
											certno: item.nationalCode,
											pasport: item.passportNo,
											profilestatus: item.profileStatus,
											paymentstatus: item.paymentStatus,
											plan: "-",
											action: (
												<div style={{ display: "flex", gap: "1rem" }}>
													<Link
														style={{ width: "2.5rem", height: "2.5rem", margin: "auto" }}
														className="btn-normal arrow-naghs"
														to={_adr.Root + _adr.CreditCard.Index + _adr.SimCardPurchase.Pending.upload}
														state={item}>
														<EditOutlined />
													</Link>
													<Link
														style={{ height: "2.5rem", margin: "auto" }}
														className="btn-normal arrow-naghs"
														to={_adr.Root + _adr.CreditCard.Index + _adr.SimCardPurchase.Pending.upload}
														state={item}>
														انتخاب
													</Link>
												</div>
											),
										}))}></Table>
								</div>
							)}
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDList;
